/**
 * CreatorProGateProvider — one app-level upgrade popup + `openGate(sku)` (Jul 2026).
 *
 * Randy: every locked control now opens the FULL Creator Pro buffet ("Unlock the
 * full My Silo toolkit") with the tapped feature pre-selected and already-owned
 * tools shown as OWNED — instead of a small per-feature card. One consistent CTA
 * everywhere. Must live inside <BrowserRouter> (the popup navigates).
 */
import { createContext, useContext, useState, useCallback } from "react";
import CreatorProBuffetModal from "@/components/CreatorProBuffetModal";

const Ctx = createContext({ openGate: () => {} });
export const useCreatorProGate = () => useContext(Ctx);

export default function CreatorProGateProvider({ children }) {
  // Jul 2026 (Randy) — openGate accepts a single SKU key OR an array of keys
  // (e.g. the create-silo Step-0 flows preselect a whole toolkit set).
  const [sku, setSku] = useState(null);
  const openGate = useCallback((s) => setSku(s), []);
  return (
    <Ctx.Provider value={{ openGate }}>
      {children}
      <CreatorProBuffetModal
        open={!!sku}
        onOpenChange={(v) => { if (!v) setSku(null); }}
        preselect={sku ? (Array.isArray(sku) ? sku : [sku]) : null}
        initialMode="customize"
      />
    </Ctx.Provider>
  );
}
